import { defineStore } from 'pinia';

export default defineStore({
  id: 'meta',
  state: () => ({
    meta: {},
    agencyList: [],
    cityList: [],
    provinceList: [],

    genderList: [],
    ethnoList: [],
    ageList: [],
    referralList: [],
    avatarList: [],
    avatarColorList: [],
  }),
  actions: {
    setAgencyList(records) {
      this.agencyList = records;
    },
    setCityList(records) {
      this.cityList = records;
    },
    setProvinceList(records) {
      this.provinceList = records;
    },

    setGenderList(records) {
      this.genderList = records;
    },
    setEthnoList(records) {
      this.ethnoList = records;
    },
    setAgeList(records) {
      this.ageList = records;
    },
    setReferralList(records) {
      this.referralList = records;
    },
    setAvatarList(records) {
      this.avatarList = records;
    },
    setAvatarColorList(records) {
      this.avatarColorList = records;
    },
  },
});
